import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-accent-50/50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
              / About The Editorial Team
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
              What Is an <span className="italic text-accent-600">AllChinaBuy Spreadsheet</span>?
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
              <p>
                An <strong>AllChinaBuy spreadsheet</strong> is a carefully curated, regularly updated list of products available through the AllChinaBuy platform. It organizes thousands of items — from sneakers and hoodies to bags and accessories — by category, brand, seller rating, and price, making it dramatically easier to find exactly what you are looking for.
              </p>
              <p>
                Our editorial team researches spreadsheet products, verifies seller reputations, and compiles buying guides to help users make informed purchasing decisions. Instead of scrolling through endless unverified listings, our <strong>AllChinaBuy spreadsheet</strong> gives you a structured, trustworthy starting point for every shopping session.
              </p>
              <p>
                Whether you are a beginner looking for your first purchase or an experienced shopper hunting for hidden gems, our <Link to="/article/allchinabuy-spreadsheet-complete-guide" className="text-primary-600 font-medium underline hover:text-primary-700 transition-colors cursor-pointer">complete guide</Link> walks you through every step of the process.
              </p>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-circle-fill text-[6px] text-accent-500"></i>
                Trusted Review Process
              </span>
              <span className="text-foreground-300">|</span>
              <span className="text-xs text-foreground-500">Last Updated: June 2026</span>
            </div>
          </div>

          <div className="relative">
            <div className="bg-background-50 rounded-3xl p-8 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="flex -space-x-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20young%20man%20editorial%20team%20portrait%20in%20soft%20warm%20natural%20lighting%20near%20window%2C%20minimalist%20clean%20cream%20wall%20background%2C%20friendly%20confident%20expression%2C%20modern%20casual%20professional%20headshot%20style%20with%20gentle%20shadows%20and%20shallow%20depth%20of%20field&width=80&height=80&seq=editor-v2-01-z30&orientation=squarish"
                    alt="Editorial team member"
                    className="w-12 h-12 rounded-full object-cover border-2 border-background-50"
                    style={{ zIndex: 4 }}
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20woman%20editorial%20team%20portrait%20in%20soft%20warm%20golden%20hour%20lighting%2C%20minimalist%20light%20grey%20wall%20background%2C%20genuine%20warm%20smile%2C%20modern%20professional%20headshot%20style%20with%20soft%20diffused%20shadows%20and%20natural%20expression&width=80&height=80&seq=editor-v2-02-z31&orientation=squarish"
                    alt="Editorial team member"
                    className="w-12 h-12 rounded-full object-cover border-2 border-background-50"
                    style={{ zIndex: 3 }}
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20editorial%20team%20member%20portrait%20in%20soft%20natural%20window%20lighting%2C%20minimalist%20warm%20white%20studio%20background%2C%20friendly%20approachable%20expression%2C%20modern%20casual%20professional%20headshot%20with%20gentle%20shadows%20and%20relaxed%20confidence&width=80&height=80&seq=editor-v2-03-z32&orientation=squarish"
                    alt="Editorial team member"
                    className="w-12 h-12 rounded-full object-cover border-2 border-background-50"
                    style={{ zIndex: 2 }}
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20young%20woman%20editorial%20team%20headshot%20in%20soft%20warm%20natural%20lighting%2C%20minimalist%20clean%20pale%20background%2C%20bright%20friendly%20smile%2C%20modern%20professional%20portrait%20style%20with%20gentle%20shadows%20and%20approachable%20warmth&width=80&height=80&seq=editor-v2-04-z33&orientation=squarish"
                    alt="Editorial team member"
                    className="w-12 h-12 rounded-full object-cover border-2 border-background-50"
                    style={{ zIndex: 1 }}
                  />
                </div>
                <span className="text-sm font-semibold text-foreground-800">Our Editorial Team</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Our team researches spreadsheet products, buying methods, and shopping guides to help users make informed decisions. Content is reviewed regularly to maintain accuracy and relevance for the <strong>AllChinaBuy spreadsheet</strong> community.
              </p>
              <p className="text-xs text-foreground-400 mt-4 italic">
                Disclaimer: Information is provided for educational and informational purposes. All external links point to kaspreadsheet.com.
              </p>
            </div>

            <div className="absolute -bottom-4 -right-4 w-full h-full bg-accent-200/30 rounded-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}